/**
 * PoweredByStripe — official "Powered by Stripe" trust badge.
 *
 * Refuerza la seguridad/confianza en checkouts (drawer embebido, CTAs, etc.).
 * Tres variantes oficiales (SVG en Cloudinary):
 *   - "white"   → fondos oscuros (default — el sitio es dark)
 *   - "blurple" → color original de Stripe (fondos claros/neutros)
 *   - "black"   → fondos claros
 *
 * Uso: <PoweredByStripe />  ó  <PoweredByStripe variant="blurple" className="h-6" />
 */

import { cn } from "@/lib/utils";

const STRIPE_BADGE_SRC = {
  white:
    "https://res.cloudinary.com/nm-creators/image/upload/v1781711564/Powered_by_Stripe_-_white_csam6q.svg",
  blurple:
    "https://res.cloudinary.com/nm-creators/image/upload/v1781711564/Powered_by_Stripe_-_blurple_qwmllm.svg",
  black:
    "https://res.cloudinary.com/nm-creators/image/upload/v1781711564/Powered_by_Stripe_-_black_sa18ou.svg",
} as const;

export type PoweredByStripeVariant = keyof typeof STRIPE_BADGE_SRC;

export function PoweredByStripe({
  variant = "white",
  className,
}: {
  variant?: PoweredByStripeVariant;
  className?: string;
}) {
  return (
    <img
      src={STRIPE_BADGE_SRC[variant]}
      alt="Powered by Stripe"
      width={120}
      height={26}
      loading="lazy"
      decoding="async"
      draggable={false}
      className={cn("h-[26px] w-auto select-none", className)}
    />
  );
}

export default PoweredByStripe;
